import { matchPath } from 'react-router-dom';

export function getParams(path, pattern) {
    const match = matchPath(path, { path: pattern });
    return match ? match.params : {};
}
